<template>
  <GenericLayout :title="$t('TERMS_OF_SERVICE')" class="fill-height">
    <TosEs v-if="$i18n.locale === 'es'" />
    <TosEn v-else />
  </GenericLayout>
</template>

<style scoped>
>>> .container {
  max-width: 800px;
  margin: 0 auto;
}

>>> h1 {
  text-align: center;
  margin: 16px 0 32px;
}
</style>

<script>
import GenericLayout from '@/layouts/GenericLayout.vue';

import TosEs from '@/views/legal/TosEs.vue';
import TosEn from '@/views/legal/TosEn.vue';

export default {
  name: 'Tos',
  components: {
    GenericLayout,
    TosEs,
    TosEn,
  },
};
</script>
